"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptySlot = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var styles = __importStar(require("./SignatureSlot.css"));
var classnames_1 = __importDefault(require("classnames"));
var SignatureSlot_1 = require("./SignatureSlot");
var typeToAction = function (type) {
    if (type === SignatureSlot_1.SlotType.Signature) {
        return "Sign";
    }
    return "Initial";
};
var EmptySlot = function (_a) {
    var onClick = _a.onClick, onKeyDown = _a.onKeyDown, type = _a.type, name = _a.name, locked = _a.locked, isCritical = _a.isCritical, isMultiAccept = _a.isMultiAccept, hasPrefilledName = _a.hasPrefilledName, _b = _a.alwaysHideName, alwaysHideName = _b === void 0 ? false : _b;
    var showName = !alwaysHideName && (isMultiAccept || hasPrefilledName);
    return (react_1.default.createElement("button", { onClick: onClick, onKeyDown: onKeyDown, className: (0, classnames_1.default)(styles.button({ disabled: locked, isCritical: isCritical, filled: false }), styles.emptySignatureButton, "signature-slot-empty-button"), disabled: locked, "aria-disabled": locked, type: "button" },
        react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.container({ locked: locked }), paddingLeft: "l", paddingRight: "l", paddingTop: showName ? "s" : "m", paddingBottom: showName ? "s" : "m", align: "center", justify: "center" },
            react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: showName ? "xs" : "s", align: "center", className: styles.labelOverride }, typeToAction(type)),
            showName && (react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s", align: "center", className: styles.labelOverride }, name)))));
};
exports.EmptySlot = EmptySlot;
